const destinations = [
  {
    name: "Germany (Grafenwoehr, Wiesbaden, Berlin)",
    context: "Fort Johnson PCS assignments to USAREUR units, NATO exercises, business travel to Frankfurt and Munich",
    urgency: "PCS orders often arrive with 30–45 days to report — dependent passports must be current",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "South Korea (Camp Humphreys, Seoul)",
    context: "Fort Johnson soldiers assigned to 2ID or USFK commands, DMZ rotations, KATUSA training",
    urgency: "OCONUS assignment orders can have 30-day report dates with no flexibility",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom (London, Edinburgh)",
    context: "Medical CME conferences, energy sector business travel, legal and financial services meetings",
    urgency: "Medical conference registrations lock in months ahead — but flights are often booked 4–6 weeks out",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Brazil (São Paulo, Santos, Rio)",
    context: "Agricultural trade delegations, agribusiness commodity meetings, sugarcane and soybean export negotiations",
    urgency: "Trade delegation travel is confirmed 4–8 weeks before departure with limited flexibility",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Italy (Vicenza, Rome, Milan)",
    context: "Fort Johnson families stationed with the 173rd Airborne Brigade in Vicenza; heritage tourism",
    urgency: "Dependent family members sometimes have expired passports discovered during PCS preparation",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "France & Spain",
    context: "LSUA and Louisiana College study-abroad programs, medical conference travel, heritage tourism",
    urgency: "Study-abroad program deadlines are fixed — standard processing frequently misses them",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "200 mi", label: "distance to the nearest regional passport agency from Alexandria — 400-mile round trip that Fast Passport Center eliminates" },
  { stat: "45%", label: "of Alexandria expedited requests are military-related — Fort Johnson families receiving PCS orders" },
  { stat: "30 Days", label: "typical PCS report date window for Fort Johnson overseas assignments — creating the tightest passport timeline in Central Louisiana" },
  { stat: "AEX + IAH", label: "primary flight path for Central Louisiana international travelers — connecting through Houston or Dallas to the world" },
];

export default function AlexandriaDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Alexandria Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Central Louisiana clients. Understanding Fort Johnson timelines, medical conference calendars, and agricultural trade delegation windows is core to what we do.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Louisiana Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Louisiana with the same expedited passport processing expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[
                { name: "Shreveport", href: "/cities/shreveport" },
                { name: "Monroe", href: "/cities/monroe" },
                { name: "Baton Rouge", href: "/cities/baton-rouge" },
                { name: "New Orleans", href: "/cities/new-orleans" },
              ].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}